import * as types from "../constants/actionTypes";
import initialState from "./initialState";

export const alternativeSearchReducer = (
  state = initialState.alternativeSearch,
  action
) => {
  switch (action.type) {
    case types.GET_ROOM_RESULTS_SUCESS:
      return (
        action.payload && action.payload.filter(room => room.alternativeSearch)
      );

    default:
      return state;
  }
};

export const alternativeSearchErrorMessageReducer = (
  state = initialState.alternativeSearchErrorMessage,
  action
) => {
  switch (action.type) {
    case types.GET_ROOM_RESULTS_SUCESS:
      return (
        action.payload &&
        action.payload.filter(room => room.alternativeSearchErrorMessage)
      );

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/alternativeSearchReducer.js